export const JOB_STATE_DRAFT = 'draft';
export const JOB_STATE_ZIP = 'zip';
export const JOB_STATE_PROCESSING = 'processing';
export const JOB_STATE_COMPLETE = 'completed';
export const JOB_STATE_FAILED = 'failed';
export const JOB_STATE_INCOMPLETE = 'incomplete';
export const JOB_STATE_NOT_FOUND = 'not_found';
export const JOB_STATE_UPLOADING = 'uploading';
export const JOB_STATE_PREPARING = 'preparing';
export const JOB_STATE_SELECT_OUTPUT = 'select_output';

export const JOB_COMPLETED_STATES = [JOB_STATE_COMPLETE, JOB_STATE_ZIP]